import R from 'app/assets/R'
import { BaseModalComponent } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { useTranslation } from 'react-i18next'
import { HookFormCommon } from '../hook'
import { useHook } from './hook'
import { IProps } from './type'

export const UpdateModalLayout = (props: IProps) => {
  const { t } = useTranslation()

  const {
    form,
    modalRef,
    handleSubmit,
    isLoading,
    isLoadingTradeUnionMember,
    tums,
    onChangeUnitType,
    unitType,
    setTumIdsSelected,
    tumIdsSelected
  } = useHook(props)

  
  return (
    <BaseModalComponent
      titleModal={'Cập nhật đơn vị'}
      titleOpenModal={t(R.strings.update)}
      ref={modalRef}
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} initialValues={{}} onFinish={handleSubmit}>
          <HookFormCommon
            onChangeUnitType={onChangeUnitType}
            unitType={unitType}
            tums={tums}
            isLoadingTradeUnionMember={isLoadingTradeUnionMember}
            form={form}
            setTumIdsSelected={setTumIdsSelected}
            tumIdsSelected={tumIdsSelected}
          />
        </BaseForm>
      }
    />
  )
}
